import { Attributes, Misc, NeoModel, ValueObject, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class SecurityHoldingsDataExtractReportCriteria extends ValueObject {
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public date: Date | null = null;

    public clientAccountId: number | null = null;

    public brokerAccountNumber: string | null = null;

    public staticInstrumentId: number | null = null;

    public instrumentDisplayName: string | null = null;
}